import { useState } from 'react';
import { FileText, ChevronRight, ChevronDown } from 'lucide-react';
import { useIsBelowLg } from '@/hooks/use-mobile';

interface ProjectFloorPlansProps {
  floorPlanImages?: any[];
}

export function ProjectFloorPlans({ floorPlanImages }: ProjectFloorPlansProps) {
  const [selected, setSelected] = useState(0);
  const [expandedMobile, setExpandedMobile] = useState<number | null>(null);
  const isMobile = useIsBelowLg();

  if (!floorPlanImages || floorPlanImages.length === 0) return null;

  const plans = floorPlanImages.map((img: any, i: number) => ({
    name: `Floor ${i + 1}`,
    image: img.url,
  }));

  if (isMobile) {
    return (
      <section>
        <h2 className="font-display text-lg md:text-xl font-bold mb-3">Project Master Plans</h2>
        <div className="border rounded-xl overflow-hidden divide-y">
          {plans.map((plan, i) => {
            const open = expandedMobile === i;
            return (
              <div key={i}>
                <button
                  onClick={() => setExpandedMobile(open ? null : i)}
                  className="w-full flex items-center justify-between px-4 py-3.5 text-left"
                >
                  <div className="flex items-center gap-3">
                    <FileText className="h-5 w-5 text-muted-foreground" />
                    <span className="text-sm font-medium">{plan.name}</span>
                  </div>
                  {open ? <ChevronDown className="h-4 w-4 text-muted-foreground" /> : <ChevronRight className="h-4 w-4 text-muted-foreground" />}
                </button>
                {open && (
                  <div className="bg-muted/30 p-4 flex items-center justify-center">
                    <img src={plan.image} alt={plan.name} className="max-w-full max-h-[300px] object-contain rounded-lg" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>
    );
  }

  return (
    <section>
      <h2 className="font-display text-xl font-bold mb-4">Project Master Plans</h2>
      <div className="border rounded-xl overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-3">
          <div className="border-r max-h-[420px] overflow-y-auto">
            {plans.map((plan, i) => (
              <button key={i} onClick={() => setSelected(i)}
                className={`w-full flex items-center justify-between px-5 py-4 text-left border-b last:border-b-0 transition-colors ${i === selected ? 'border-l-[3px] border-l-primary bg-primary/5 text-primary font-semibold' : 'hover:bg-muted/50 text-foreground'}`}>
                <div className="flex items-center gap-3">
                  <FileText className="h-5 w-5 text-muted-foreground" />
                  <span className="text-sm">{plan.name}</span>
                </div>
                <ChevronRight className="h-4 w-4 text-muted-foreground" />
              </button>
            ))}
          </div>
          <div className="md:col-span-2 bg-muted/30 flex items-center justify-center p-6 min-h-[350px]">
            <img src={plans[selected].image} alt={plans[selected].name} className="max-w-full max-h-[380px] object-contain rounded-lg" />
          </div>
        </div>
      </div>
    </section>
  );
}
